import React, { useState, useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { verifyPermission } from "../../helpers/permission";
import { ERROR_401 } from "../../config/errorPage";
import InfirmationTable from "../components/InfirmationTable";
import HeaderTablePage from "../components/HeaderTablePage";
import { forceRound, formatDateToTimeStampte } from "../../helpers/function";
import axios from "axios";
import appConfig from "../../config/appConfig";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { ToastBottomEnd } from "../components/Toast";
import {
  toastErrorMessageWithParameterConfig,
  toastSuccessMessageWithParameterConfig,
} from "../../config/toastConfig";
import { useTranslation } from "react-i18next";
import moment from "moment";
import LoadingTable from "../components/LoadingTable";
import FileSaver from "file-saver";

const Logs = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  document.title = "Satis Paramètre - " + (ready ? t("Logs") : "");
  const [logs, setLogs] = useState([]);
  const defaultErrors = {
    causer_id: [],
    log_action: [],
    date_start: [],
    date_end: [],
  };
  const [error, setError] = useState(defaultErrors);
  const [actor, setActor] = useState(null);
  const [actors, setActors] = useState([]);
  const [action, setAction] = useState(null);
  const [actions, setActions] = useState([]);
  const startDate = useRef(null);
  const endDate = useRef(null);
  const onePageNumber = 50;
  const [endIndex, setEndIndex] = useState(onePageNumber);
  const [loadMore, setLoadMore] = useState(false);
  const [loadFilter, setLoadFilter] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [nextUrl, setNextUrl] = useState(null);
  const [load, setLoad] = useState(false);
  const [loadDownloadPdf, setLoadDownloadPdf] = useState(false);
  const [loadDownloadExcel, setLoadDownloadExcel] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoad(true);
      setLoad(true);
      axios
        .get(`${appConfig.apiDomaine}/activity-log/create`)
        .then((response) => {
          const logData = response.data.logs;
          setNextUrl(logData.next_page_url);
          setLogs(logData.data);
          setActors(
            response.data.filters.causers.map((item) => {
              return {
                value: item.id,
                label: item.identite.lastname + " " + item.identite.firstname,
              };
            })
          );
          const logActions = response.data.filters.log_actions;
          setActions(
            Object.keys(logActions).map((item) => {
              return {
                value: item,
                label: logActions[item],
              };
            })
          );
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoad(false);
          setLoad(false);
        });
    }

    if (verifyTokenExpire()) fetchData();
  }, []);

  if (!verifyPermission(props.userPermissions, "activity-log"))
    window.location.href = ERROR_401;

  const showElements = useMemo(() => {
    return logs.slice(0, endIndex);
  }, [logs, endIndex]);

  const showMore = () => {
    if (
      endIndex / onePageNumber <
      forceRound(logs.length / onePageNumber) - 1
    ) {
      setEndIndex((i) => i + onePageNumber);
    } else {
      if (verifyTokenExpire()) {
        if (nextUrl !== null) {
          setLoadMore(true);
          axios
            .get(`${nextUrl}`)
            .then((response) => {
              setLoadMore(false);
              setNextUrl(response.data.logs.next_page_url);
              setLogs((l) => {
                return [...l, ...response.data.logs.data];
              });
              setEndIndex((i) => i + onePageNumber);
            })
            .catch((error) => {});
        }
      }
    }
  };

  const getFilterData = () => {
    const sendData = {
      causer_id: actor !== null ? actor.value : "",
      log_action: action !== null ? action.value : "",
      date_start: startDate.current.value,
      date_end: endDate.current.value,
    };
    if (!sendData.date_end) delete sendData.date_end;
    if (!sendData.date_start) delete sendData.date_start;
    if (!sendData.causer_id) delete sendData.causer_id;
    if (!sendData.log_action) delete sendData.log_action;
    return sendData;
  };

  const filterLogs = (e) => {
    e.preventDefault();
    setLoadFilter(true);
    if (verifyTokenExpire()) {
      const sendData = getFilterData();
      
      axios
        .get(`${appConfig.apiDomaine}/activity-log`, { params: sendData })
        .then((response) => {
          setNextUrl(response.data.next_page_url);
          setLogs(response.data.data);
          setEndIndex(onePageNumber);

          ToastBottomEnd.fire(
            toastSuccessMessageWithParameterConfig(t("Succès du filtrage"))
          );
          setLoadFilter(false);
          setError(defaultErrors);
          setEndIndex(onePageNumber);
        })
        .catch((error) => {
          ToastBottomEnd.fire(
            toastErrorMessageWithParameterConfig(t("Echec du filtrage"))
          );
          setError({ ...defaultErrors, ...error.response.data.error });
        })
        .finally(() => {
          setLoadFilter(false);
        });
    }
  };

  const showAction = (key) => {
    let result = "";
    actions.forEach((item) => {
      if (item.value === key) {
        result = item.label;
      }
    });
    return result;
  };

  const downloadLogsPdf = () => {
    setLoadDownloadPdf(true);
    let endpoint = `${appConfig.apiDomaine}/activity-log/download/pdf`;
    let sendData = getFilterData();

    axios({
      method: "post",
      url: endpoint,
      responseType: "blob",
      data: sendData,
    })
    .then((response) => {
      
      setError({
        causer_id: [],
        log_action: [],
        date_start: [],
        date_end: [],
      });
      let fileName =`logs_${sendData.date_start}_${sendData.date_end}`
      if (sendData.causer_id) {
        fileName += `_${sendData.causer_id}`
      }
      if (sendData.log_action) {
        fileName += `_${sendData.log_action}`
      }
      FileSaver.saveAs(
        response.data,
        `${fileName}.pdf`
      );
    })
    .catch((error) => {
      console.log(error);
      
      setError({
        causer_id: [],
        log_action: [],
        date_start: [],
        date_end: [],
        ...error?.response?.data?.error,
      });
      ToastBottomEnd.fire(
        toastErrorMessageWithParameterConfig(t("Echec de téléchargement du PDF"))
      );
    })
    .finally(() => {
      setLoadDownloadPdf(false);
    });
  }

  const downloadLogsExcel = () => {
    setLoadDownloadExcel(true);
    let endpoint = `${appConfig.apiDomaine}/activity-log/download/excel`;
    let sendData = getFilterData();

    axios({
      method: "post",
      url: endpoint,
      responseType: "blob",
      data: sendData,
    })
    .then((response) => {
      
      setError({
        causer_id: [],
        log_action: [],
        date_start: [],
        date_end: [],
      });
      let fileName =`logs_${sendData.date_start}_${sendData.date_end}`
      if (sendData.causer_id) {
        fileName += `_${sendData.causer_id}`
      }
      if (sendData.log_action) {
        fileName += `_${sendData.log_action}`
      }
      FileSaver.saveAs(
        response.data,
        `${fileName}.xlsx`
      );
    })
    .catch((error) => {
      console.log(error);
      
      setError({
        causer_id: [],
        log_action: [],
        date_start: [],
        date_end: [],
        ...error?.response?.data?.error,
      });
      ToastBottomEnd.fire(
        toastErrorMessageWithParameterConfig(t("Echec de téléchargement du fichier Excel"))
      );
    })
    .finally(() => {
      setLoadDownloadExcel(false);
    });
  }

  return ready
    ? verifyPermission(props.userPermissions, "activity-log") && (
        <div
          className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
          id="kt_content"
        >
          <div className="kt-subheader   kt-grid__item" id="kt_subheader">
            <div className="kt-container  kt-container--fluid ">
              <div className="kt-subheader__main">
                <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
                <span className="kt-subheader__separator kt-hidden" />
                <div className="kt-subheader__breadcrumbs">
                  <span className="kt-subheader__separator kt-hidden" />
                  <div className="kt-subheader__breadcrumbs">
                    <a href="#icone" className="kt-subheader__breadcrumbs-home">
                      <i className="flaticon2-shelter" />
                    </a>
                    <span className="kt-subheader__breadcrumbs-separator" />
                    <a
                      href="#button"
                      onClick={(e) => e.preventDefault()}
                      className="kt-subheader__breadcrumbs-link"
                    >
                      {t("Journal des activités")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
            <InfirmationTable
              information={t("Historique des activitées du système")}
            />

            <div className="kt-portlet">
              <HeaderTablePage title={t("Journal des activités")} />

              <div className="kt-portlet__body">
                <div
                  id="kt_table_1_wrapper"
                  className="dataTables_wrapper dt-bootstrap4"
                >
                  <form
                    className="kt-form kt-form--fit kt-margin-b-20"
                    onSubmit={filterLogs}
                  >
                    <div className="form-group row bg-light pb-3 pt-3 rounded">
                      <div className="col">
                        <div className="form-group row">
                          <div className="col">
                            <label htmlFor="actor">{t("Acteur")}</label>
                            <Select
                              options={actors}
                              value={actor}
                              isLoading={isLoad}
                              onChange={(value) => setActor(value)}
                              placeholder={t("Veuillez sélectionner l'acteur")}
                              isClearable
                            />
                          </div>

                          <div className="col">
                            <label htmlFor="actor">{t("Action")}</label>
                            <Select
                              options={actions}
                              value={action}
                              isLoading={isLoad}
                              onChange={(value) => setAction(value)}
                              placeholder={t("Veuillez sélectionner l'action")}
                              isClearable
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col">
                            <label htmlFor="actor">{t("Date de début")}</label>
                            <input
                              ref={startDate}
                              defaultValue={moment()
                                .startOf("month")
                                .format("YYYY-MM-DD")}
                              type="date"
                              className={`form-control ${
                                error.date_start.length ? "is-invalid" : ""
                              }`}
                            />
                            {error.date_start.length !== 0 && (
                              <>
                                {error.date_start.map((item, index) => (
                                  <p key={index} className="invalid-feedback">
                                    {item}
                                  </p>
                                ))}
                              </>
                            )}
                          </div>

                          <div className="col">
                            <label htmlFor="actor">{t("Date de fin")}</label>
                            <input
                              ref={endDate}
                              defaultValue={moment()
                                .endOf("month")
                                .format("YYYY-MM-DD")}
                              type="date"
                              className={`form-control ${
                                error.date_end.length ? "is-invalid" : ""
                              }`}
                            />
                            {error.date_end.length !== 0 && (
                              <>
                                {error.date_end.map((item, index) => (
                                  <p key={index} className="invalid-feedback">
                                    {item}
                                  </p>
                                ))}
                              </>
                            )}
                          </div>
                        </div>

                        <div className="kt-form__actions text-center">
                          {loadFilter ? (
                            <button className="btn btn-primary kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light"
                            >
                              {t("Filtrer")}
                            </button>
                          ) : (
                            <button type="submit" className="btn btn-primary"
                            disabled={loadFilter || load}
                            >
                              {t("Filtrer")}
                            </button>
                          )}
                          <button
                            onClick={downloadLogsPdf}
                            className="btn btn-secondary ml-3"
                            disabled={loadDownloadPdf || load}
                          >
                          {loadDownloadPdf ? (
                              <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Loading...
                              </>
                            ) : (
                              <>
                                <i className="la la-download" /> Télécharger PDF
                              </>
                            )}

                          </button>
                          
                          <button
                            onClick={downloadLogsExcel}
                            className="btn btn-secondary ml-3"
                            disabled={loadDownloadExcel || load}
                          >
                          {loadDownloadExcel ? (
                              <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Loading...
                              </>
                            ) : (
                              <>
                                <i className="la la-download" /> Télécharger Excel
                              </>
                            )}

                          </button>
                          
                        </div>
                      </div>
                    </div>
                  </form>

                  <div className="kt-separator kt-separator--space-md" />

                  {load ? (
                    <div style={{ padding: 0, margin: 0 }}>
                      <LoadingTable />
                    </div>
                  ) : (
                    <>
                      <div className="position-relative">
                        {showElements.map((item, index) => (
                          <div key={index}>
                            <div className="tab-content">
                              <div className="d-flex justify-content-between">
                                <h5>
                                  {item.causer
                                    ? item.causer.identite
                                      ? item.causer.identite.lastname +
                                        " " +
                                        item.causer.identite.firstname
                                      : ""
                                    : ""}
                                </h5>
                                <span>
                                  {formatDateToTimeStampte(item.created_at)}
                                </span>
                              </div>
                              <div style={{ marginTop: "1%" }}>
                                <strong>{t("Action")}: </strong>
                                <span className="mx-2">
                                  {showAction(item.log_action)}
                                </span>
                              </div>

                              <div style={{ marginTop: "1%" }}>
                                <strong>IP: </strong>
                                <span className="mx-2">{item.ip_address}</span>
                              </div>

                              <div style={{ marginTop: "1%" }}>
                                <strong>{t("Description")}: </strong>
                                <span className="mx-2">{item.description}</span>
                              </div>
                            </div>
                            <div className="kt-separator kt-separator--space-md kt-separator--border-dashed" />
                          </div>
                        ))}
                      </div>

                      <div className="text-center">
                        {loadMore ? (
                          <button className="btn btn-primary kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light">
                            {t("Voir plus")}
                          </button>
                        ) : (
                          <button
                            onClick={showMore}
                            hidden={true}
                            className="btn btn-primary"
                          >
                            {t("Voir plus")}
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    : null;
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
  };
};

export default connect(mapStateToProps)(Logs);
